
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useNavigate, useLocation } from "react-router-dom";
import { DollarSign, Package, FileText, User } from "lucide-react";

interface NavItem {
  icon: React.ElementType;
  label: string;
  path: string;
}

export function MobileBottomNav() {
  const navRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems: NavItem[] = [
    {
      icon: DollarSign,
      label: "Dashboard",
      path: "/adm/dashboard"
    }, 
    {
      icon: FileText,
      label: "Orçamentos",
      path: "/adm/quotations"
    }, 
    {
      icon: Package,
      label: "Estoque",
      path: "/adm/stock"
    }, 
    {
      icon: User,
      label: "Perfil",
      path: "/adm/settings"
    }
  ];

  // Animation on mount
  useEffect(() => {
    if (!navRef.current) return;
    gsap.fromTo(navRef.current, {
      y: 100,
      opacity: 0
    }, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power3.out",
      delay: 0.2
    });
  }, []);
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div 
      ref={navRef} 
      className="fixed bottom-0 left-0 right-0 bg-[#1A1F2C] border-t border-[#2A303C] flex justify-around items-center h-16 z-50 px-1"
    >
      {navItems.map((item) => {
        const IconComponent = item.icon;
        const active = isActive(item.path);
        
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-center px-2 py-1 rounded-lg w-full h-full mx-0.5 ${
              active ? "bg-[#0073B7]/10 text-[#0073B7]" : "text-gray-400"
            }`}
          >
            <IconComponent size={20} className={active ? "text-[#0073B7]" : "text-gray-400"} />
            <span className="text-xs mt-1 font-medium">{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}
